import React from 'react';
import { formatCurrency, formatDate } from '@/utils/formatters';
import { useAppContext } from '@/context/AppContext';

export default function PlannedItem({ planned, onDelete, onEdit, selectable = false, selected = false, onSelect }) {
  const { plannedLabels } = useAppContext();
  const labelMap = Object.fromEntries(plannedLabels.map(l => [l.id, l.label]));
  return (
    <div className="card border-l-4 border-warning">
      <div className="flex justify-between items-start gap-2">
        {/* Checkbox (selection mode) */}
        {selectable && (
          <input
            type="checkbox"
            checked={selected}
            onChange={() => onSelect?.(planned.id)}
            aria-label={`Select ${planned.vendor}`}
            className="w-4 h-4 accent-orange-500 flex-shrink-0 mt-1"
          />
        )}

        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold text-gray-800">{planned.vendor}</p>
          <p className="text-xs text-gray-500 mt-0.5">{planned.description}</p>
        </div>
        <div className="text-right ml-3">
          <p className="text-lg font-bold text-warning">{formatCurrency(planned.amount)}</p>
          {!selectable && (
            <div className="flex gap-2 justify-end mt-0.5">
              <button
                onClick={() => onEdit?.(planned)}
                aria-label={`Edit ${planned.vendor}`}
                className="text-gray-400 hover:text-primary text-xs transition-colors"
              >
                Edit
              </button>
              <button
                onClick={() => {
                  if (confirm('Delete this planned expense?')) onDelete(planned.id);
                }}
                aria-label={`Delete ${planned.vendor}`}
                className="text-gray-300 hover:text-danger text-xs transition-colors"
              >
                Delete
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="flex gap-2 mt-2 flex-wrap">
        <span className="inline-block px-2 py-0.5 rounded-chip text-xs font-semibold bg-warning-light text-warning">
          {labelMap[planned.label] ?? planned.label}
        </span>
        <span className="text-xs text-gray-400">{formatDate(planned.date)}</span>
        <span className="text-xs text-gray-400">by {planned.createdBy}</span>
      </div>
    </div>
  );
}
